import React from "react";
import classNames from "classnames";
import Icon from "../elements/icon";
import PropTypes from "prop-types";
import PlainButton from "../elements/plain-button";

var FlexTableSortHeaderCell = function FlexTableSortHeaderCell(props) {
  return /*#__PURE__*/React.createElement(PlainButton, {
    className: classNames("et--flex-table--sort-header-cell", props.className),
    onClick: props.onClick
  }, props.children, props.isSorted && /*#__PURE__*/React.createElement(Icon, {
    className: props.iconClassName,
    icon: props.sortOrder ? "arrow-down" : "arrow-up"
  }));
};

FlexTableSortHeaderCell.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  isSorted: PropTypes.bool,
  iconClassName: PropTypes.string,
  sortOrder: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.number, PropTypes.array, PropTypes.string])
};
export default FlexTableSortHeaderCell;